import { render, staticRenderFns } from "./BlanketLayout.vue?vue&type=template&id=5c2419c3&scoped=true"
import script from "./BlanketLayout.vue?vue&type=script&lang=js"
export * from "./BlanketLayout.vue?vue&type=script&lang=js"
import style0 from "./BlanketLayout.vue?vue&type=style&index=0&id=5c2419c3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c2419c3",
  null
  
)

export default component.exports